// extracted by mini-css-extract-plugin
module.exports = {"container":"GameScoreContainer_container__XgSPo","scoreContainer":"GameScoreContainer_scoreContainer__1tmvF"};